export default __webpack_public_path__ + "static/media/pictogramBeaconDisability64.87f78626.svg";